import { createAction, handleActions } from 'redux-actions';
import { createSelector } from 'reselect';

import { useRedux } from 'util/hook/redux';

export const openConfirm = createAction('OPEN_CONFIRM', (message, note, action) => ({
	message,
	note,
	action,
}));

export const openWarningConfirm = data => openConfirm('warning', data);

export const closeConfirm = createAction('CLOSE_CONFIRM');

export const enterConfirm = createAction('ENTER_CONFIRM', () => (dispatch, getState) => {
	const {
		confirm: { action },
	} = getState();
	dispatch(action);
});

const reducer = {
	confirm: handleActions(
		{
			OPEN_CONFIRM: (state, action) => ({
				...state,

				active: true,
				message: action.payload.message,
				note: action.payload.note,
				action: action.payload.action,
			}),

			CLOSE_CONFIRM: state => ({
				...state,

				active: false,
				message: '',
				note: '',
				action: () => {},
			}),

			ENTER_CONFIRM: state => ({
				...state,

				active: false,
				message: '',
				note: '',
				action: () => {},
			}),
		},
		{
			active: false,
			message: '',
			note: '',
			action: () => {},
		},
	),
};

const selectConfirm = createSelector(
	state => state.confirm,
	confirm => confirm,
);

export const useConfirm = () =>
	useRedux(selectConfirm, { openConfirm, closeConfirm, enterConfirm });

export default { reducer };
